$('.m_slider').slick({  
    fade: true,
    speed: 1500,
    autoplaySpeed: 3000,
    arrows: false,
    autoplay: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true
	});




$(function () {
  if (window.matchMedia('(max-width: 768px)').matches) {
$('.scroll-list').slick({  
    autoplay: true,//自動でスライドさせる
    autoplaySpeed: 0,//次の画像に切り替えるまでの時間 今回の場合は0
    speed: 8000,//画像が切り替わるまでの時間 今回の場合は難病で1枚分動くか
    cssEase: 'linear',//動きの種類は等速に
    arrows:false,//左右に出る矢印を非表示
    swipe: false,//スワイプ禁止
    pauseOnFocus: false,//フォーカスが合っても止めない
    pauseOnHover: false,//hoverしても止めない
    slidesToShow: 2,
	});
  } else {
$('.scroll-list').slick({  
    autoplay: true,//自動でスライドさせる
    autoplaySpeed: 0,//次の画像に切り替えるまでの時間 今回の場合は0
    speed: 8000,//画像が切り替わるまでの時間 今回の場合は難病で1枚分動くか
    cssEase: 'linear',//動きの種類は等速に
    arrows:false,//左右に出る矢印を非表示
    swipe: false,//スワイプ禁止
    pauseOnFocus: false,//フォーカスが合っても止めない
    pauseOnHover: false,//hoverしても止めない
    slidesToShow: 6,
	});
  }
})